export default "__VITE_ASSET__CuaLWZ6Y__"